import { createAction } from '@reduxjs/toolkit';
const prefix = 'elevio/search';
export const searchActions = {
    setInitialConversationSearchState: createAction(`${prefix}/setInitialConversationSearchState`),
    setSearchTerm: createAction(`${prefix}/setSearchTerm`),
    initialiseInputValue: createAction(`${prefix}/initialiseInputValue`),
    setSearchInputValue: createAction(`${prefix}/setSearchInputValue`),
    searchRequest: createAction(`${prefix}/searchRequest`),
    searchSuccess: createAction(`${prefix}/searchSuccess`),
    searchFailure: createAction(`${prefix}/searchFailure`),
};
